export default __webpack_public_path__ + "static/media/bannerImage-2.13ab7eff.jpg";